var _path, _path2, _path3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatus2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9648 28.0256H26.2756",
    stroke: "#266A4A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8688 28.0256H39.304",
    stroke: "#266A4A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_625_2313",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 70,
    height: 70
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9999 69V1.00012H1V69H68.9999Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_625_2313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.8689 31.95V23.4577C55.8689 21.7045 54.4477 20.2835 52.6947 20.2835H48.969",
    stroke: "#266A4A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.965 20.2836H4.19993C2.44693 20.2836 1.02588 21.7047 1.02588 23.4578V62.6261C1.02588 64.3791 2.44693 65.8003 4.19993 65.8003H52.6949C54.448 65.8003 55.8691 64.3791 55.8691 62.6261V43.3462",
    stroke: "#266A4A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5035 20.2837H39.304",
    stroke: "#266A4A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8103 28.0256H18.9729L17.9332 25.6238C17.6818 25.0431 17.1095 24.6673 16.4767 24.6673H9.51312C8.88039 24.6673 8.30808 25.0431 8.05666 25.6238L7.01691 28.0256H1.02563",
    stroke: "#266A4A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.759 24.1694V24.1535",
    stroke: "#266A4A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1755 24.1694V24.1535",
    stroke: "#266A4A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.592 24.1694V24.1535",
    stroke: "#266A4A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1683 33.0669C40.3041 31.1989 38.4108 27.9666 38.4108 24.2928C38.4108 18.5107 43.0981 13.8235 48.8803 13.8235C54.6624 13.8235 59.3483 18.5107 59.3483 24.2928C59.3483 30.0734 54.6624 34.7608 48.8803 34.7608C48.6372 34.7608 48.3962 34.7525 48.1573 34.7362M64.5659 36.8499C67.3236 33.4102 68.9742 29.0446 68.9742 24.2928C68.9742 13.1957 59.9775 4.19904 48.8803 4.19904C37.7831 4.19904 28.7864 13.1957 28.7864 24.2928C28.7864 35.39 37.7831 44.3853 48.8803 44.3853C53.6169 44.3853 57.97 42.7455 61.4051 40.0038",
    stroke: "#266A4A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3484 24.293H68.9743",
    stroke: "#266A4A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8804 4.19905V13.8235",
    stroke: "#266A4A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1243 10.656C36.3993 12.9252 38.6708 15.1979 40.9443 17.4685",
    stroke: "#266A4A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7087 44.1886L32.3363 46.8162L43.823 35.3295",
    stroke: "#266A4A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8047 47.5539L19.2202 50.8445L25.8762 44.1886",
    stroke: "#266A4A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3059 33.415C48.3059 34.8336 47.156 35.9836 45.7374 35.9836C44.3186 35.9836 43.1687 34.8336 43.1687 33.415C43.1687 31.9962 44.3186 30.8463 45.7374 30.8463C47.156 30.8463 48.3059 31.9962 48.3059 33.415Z",
    stroke: "#266A4A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3463 42.2765C30.3463 43.6953 29.1962 44.8452 27.7777 44.8452C26.3589 44.8452 25.209 43.6953 25.209 42.2765C25.209 40.858 26.3589 39.7079 27.7777 39.7079C29.1962 39.7079 30.3463 40.858 30.3463 42.2765Z",
    stroke: "#266A4A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3744 45.6257C16.3744 47.0443 15.2243 48.1943 13.8057 48.1943C12.3871 48.1943 11.2371 47.0443 11.2371 45.6257C11.2371 44.2071 12.3871 43.057 13.8057 43.057C15.2243 43.057 16.3744 44.2071 16.3744 45.6257Z",
    stroke: "#266A4A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.51172 43.0571V55.1606H50.0267",
    stroke: "#266A4A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8027 53.4099V54.4009",
    stroke: "#266A4A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7776 53.4099V54.4009",
    stroke: "#266A4A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7373 53.4099V54.4009",
    stroke: "#266A4A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.22632 33.6785H12.4065",
    stroke: "#266A4A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.22632 37.3845H19.3791",
    stroke: "#266A4A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.51172 60.1404H50.0267",
    stroke: "#266A4A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus2);
export default __webpack_public_path__ + "static/media/status_2.23d00325f7fb135e69f1baa4a6e4d397.svg";
export { ForwardRef as ReactComponent };